import { useEffect, useState } from "react";

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
    const [devicePixelRatio, setDevicePixelRatio] = useState<number | undefined>(undefined);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        handleWindowSizeChange();
    }, []);

    const handleWindowSizeChange = () => {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });

        setDevicePixelRatio(window.devicePixelRatio);

        if (window.innerWidth < 992) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    };

    return { windowSize, devicePixelRatio, isMobile };
};

export default useWindowSize;
